import {useState} from 'react'
import {Button} from 'react-bootstrap'
import WithModal from './WithModal'

const DeleteConfirmationModal = ({message = '', onDelete = () => {}, children, ...props}) => {
  const [isBusy, setIsBusy] = useState(false)

  return (
    <WithModal
      modalAttrs={{size: 'sm'}}
      modalTitle={<div className="lead fs-2qx">Are You Sure?</div>}
      renderModalBody={(closeModal) => (
        <div className="p-4">
          <div className="mt-2 mb-11 text-center">
            {message || 'Do you really want to delete the record? This process cannot be undone'}
          </div>
          <div className="d-flex justify-content-between ">
            <Button
              disabled={isBusy}
              style={{width: '45%'}}
              variant="secondary"
              onClick={closeModal}
              className="rounded-0"
            >
              Cancel
            </Button>
            <Button
              style={{width: '45%'}}
              variant="danger"
              disabled={isBusy}
              onClick={() => {
                setIsBusy(true)
                onDelete()
                  .then((res) => {
                    setIsBusy(false)
                    closeModal()
                  })
                  .catch((err) => {
                    console.error(err)
                    throw err
                  })
                  .finally(() => setIsBusy(false))
              }}
              className="rounded-0"
            >
              Delete
            </Button>
          </div>
        </div>
      )}
      {...props}
    >
      {children}
    </WithModal>
  )
}

export default DeleteConfirmationModal
